// WhyWayo.jsx
import React from "react";
import { Gift } from "lucide-react";
import "./WhyWayo.css";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";

const users = [
  { image: "/assets/img/memoji/7294811.webp",    name: "Ana M.",     label: "Perdió 8 kg",        position: "wu-1", anim: "wuFloat1" },
  { image: "/assets/img/memoji/7309681.webp",    name: "Carlos R.",  label: "Masa muscular +4%",  position: "wu-2", anim: "wuFloat2" },
  { image: "/assets/img/memoji/8806247.webp",    name: "Elena S.",   label: "Sin rebote",         position: "wu-3", anim: "wuFloat3" },
  { image: "/assets/img/memoji/9439767.webp",    name: "Laura G.",   label: "Déficit controlado", position: "wu-4", anim: "wuFloat4" },
  { image: "/assets/img/memoji/9439833.webp",    name: "Marco T.",   label: "Maratón completado", position: "wu-5", anim: "wuFloat5" },
  { image: "/assets/img/memoji/9440461.webp",    name: "Javier F.",  label: "Hábito de 90 días",  position: "wu-6", anim: "wuFloat6" },
  { image: "/assets/img/memoji/10491846.webp",   name: "Daniela R.", label: "Energía constante",  position: "wu-7", anim: "wuFloat7" },
  { image: "/assets/img/memoji/androgynous-avatar-non-binary-queer-person.webp", name: "Carmen L.", label: "Dieta vegana ok", position: "wu-8", anim: "wuFloat8" },
];

export default function WhyWayo() {
  return (
    <section id="why" className="why-section">
      <div className="why-bg-effects">
        <div className="why-orb why-orb-1"></div>
        <div className="why-orb why-orb-2"></div>
        <div className="why-orb why-orb-3"></div>
      </div>
      <div className="why-grid-pattern"></div>

      <div className="why-container">

        {/* Título centrado */}
        <div className="why-header">
          <span className="why-badge">Lo que obtienes</span>
          <h2 className="why-title">
            Tu comida, tu plan y<br />
            <span className="title-highlight">tu entrenador</span><br />
            <span className="title-highlight">en la misma app</span>
          </h2>
        </div>

        {/* 3 cards en fila */}
        <div className="why-cards-row">
          <div className="why-card">
            <div className="why-card-icon">✓</div>
            <strong>Foto al plato —o díselo hablando— y calorías al instante</strong>
            <p>Sin escribir, sin buscar. Hazle una foto o cuéntale lo que has comido: la IA reconoce tus platos caseros y te da los macros en segundos.</p>
          </div>
          <div className="why-card">
            <div className="why-card-icon">✓</div>
            <strong>Tu plan de dieta y entreno en un solo lugar</strong>
            <p>Tu coach te asigna rutinas y comidas. Tú solo sigues el calendario y avanzas.</p>
          </div>
          <div className="why-card">
            <div className="why-card-icon">✓</div>
            <strong>Entrenadores personales a un clic</strong>
            <p>Encuentra el coach que encaja con tu objetivo, revisa sus planes y empieza hoy.</p>
          </div>
        </div>

        {/* Constelación centrada */}
        <div className="why-visual">
          <div className="why-orbit-ring why-orbit-1"></div>
          <div className="why-orbit-ring why-orbit-2"></div>
          <div className="why-orbit-ring why-orbit-3"></div>

          <div className="why-particle why-particle-1"></div>
          <div className="why-particle why-particle-2"></div>
          <div className="why-particle why-particle-3"></div>

          <div className="why-lines">
            <svg viewBox="0 0 600 600" fill="none">
              <line className="why-connection-line" x1="300" y1="300" x2="150" y2="60" />
              <line className="why-connection-line" x1="300" y1="300" x2="460" y2="45" />
              <line className="why-connection-line" x1="300" y1="300" x2="30" y2="195" />
              <line className="why-connection-line" x1="300" y1="300" x2="550" y2="160" />
              <line className="why-connection-line" x1="300" y1="300" x2="70" y2="420" />
              <line className="why-connection-line" x1="300" y1="300" x2="560" y2="435" />
              <line className="why-connection-line" x1="300" y1="300" x2="180" y2="545" />
              <line className="why-connection-line" x1="300" y1="300" x2="470" y2="555" />
            </svg>
          </div>

          <div className="why-hub">
            <img className="why-hub-photo" src="/assets/img/memoji/memoji-wayo.webp" alt="Wayo" />
            <div className="why-hub-label">wayo</div>
          </div>

          {users.map((u, i) => (
            <div key={i} className={`why-avatar ${u.position}`} style={{ animation: `${u.anim} ${5 + i * 0.7}s ease-in-out infinite` }}>
              <div className="why-avatar-ring">
                <div className="why-avatar-img">
                  <img className="why-avatar-photo" src={u.image} alt={u.name} />
                </div>
              </div>
              <div className="why-avatar-status"></div>
              <div className="why-avatar-tooltip">
                <div className="tooltip-name">{u.name}</div>
                <div className="tooltip-specialty">{u.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="why-cta">
          <div className="hero-trial-badge" style={{ marginBottom: '20px' }}>
            <strong><Gift size={16} strokeWidth={2.5} aria-hidden="true" />7 días Premium gratis</strong><br />Escanea sin límites desde el primer día
          </div>
          <div className="store-badges" style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1rem' }}>
            <a href="https://apps.apple.com/app/id6756500478" className="store-badge app-store" onClick={() => trackAppStoreClick("why_wayo")}>
              <img src={appStoreImg} alt="App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo" className="store-badge google-play" onClick={() => trackGooglePlayClick("why_wayo")}>
              <img src={googlePlayImg} alt="Google Play" />
            </a>
          </div>
          <p className="why-cta-note">Descarga gratis y entra en la comunidad de Wayo.</p>
        </div>

      </div>
    </section>
  );
}
